export { isReactCompilerActivePlatform } from './isReactCompilerActivePlatform';
